/**
 * usePeriodNavigation
 *
 * 주/월/년 기간 선택 및 네비게이션 hook
 */

import { useState, useCallback } from 'react'
import type { PeriodType } from '../types/Statistics'
import { createPeriod } from '../utils/statisticsCalculations'

export function usePeriodNavigation(initialType: PeriodType = 'month') {
  const [periodType, setPeriodType] = useState<PeriodType>(initialType)
  const [referenceDate, setReferenceDate] = useState(new Date())

  const period = createPeriod(periodType, referenceDate)

  const goToPrevious = useCallback(() => {
    const newDate = new Date(referenceDate)

    switch (periodType) {
      case 'week':
        newDate.setDate(newDate.getDate() - 7)
        break
      case 'month':
        newDate.setMonth(newDate.getMonth() - 1)
        break
      case 'year':
        newDate.setFullYear(newDate.getFullYear() - 1)
        break
    }

    setReferenceDate(newDate)
  }, [periodType, referenceDate])

  const goToNext = useCallback(() => {
    const newDate = new Date(referenceDate)

    switch (periodType) {
      case 'week':
        newDate.setDate(newDate.getDate() + 7)
        break
      case 'month':
        newDate.setMonth(newDate.getMonth() + 1)
        break
      case 'year':
        newDate.setFullYear(newDate.getFullYear() + 1)
        break
    }

    setReferenceDate(newDate)
  }, [periodType, referenceDate])

  const goToToday = useCallback(() => {
    setReferenceDate(new Date())
  }, [])

  const changePeriodType = useCallback((type: PeriodType) => {
    setPeriodType(type)
    setReferenceDate(new Date())  // 타입 변경 시 오늘로 리셋
  }, [])

  return {
    period,
    periodType,
    goToPrevious,
    goToNext,
    goToToday,
    changePeriodType
  }
}
